var _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaitingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 108,
    viewBox: "0 0 67 108",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.12476 81.1181C7.12476 73.989 9.95676 67.152 14.9977 62.111C20.0387 57.07 26.8757 54.2381 34.0048 54.2381C41.1338 54.2381 47.9708 57.07 53.0118 62.111C58.0528 67.152 60.8848 73.989 60.8848 81.118L34.0048 81.1181L7.12476 81.1181Z",
    fill: "#91CED2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.885 27.3585C60.885 34.4875 58.053 41.3246 53.012 46.3655C47.9711 51.4065 41.134 54.2385 34.005 54.2385C26.876 54.2385 20.0389 51.4065 14.998 46.3655C9.95699 41.3246 7.125 34.4875 7.125 27.3585L34.005 27.3585H60.885Z",
    fill: "#4FCEBF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.402344,
    y: 22.8789,
    width: 66.08,
    height: 4.48,
    fill: "#2E3E91"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.402344,
    y: 81.1191,
    width: 66.08,
    height: 4.48,
    fill: "#2E3E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingIcon);
export default __webpack_public_path__ + "static/media/waiting-icon.108452957acb4177bd33d0cade8b276c.svg";
export { ForwardRef as ReactComponent };